import type { PollUserActionResponse } from "@b2bportal/lloyds-user-action-cart-api";
import type { CipherText } from "@b2bportal/purchase-api";
import {
  getObjectKeysAsObject,
  setContextWithKey,
  type CartFulfillError,
  ParentState,
} from "@hopper-b2b/checkout";
import { assign, type DoneInvokeEvent } from "xstate";

import type { FlightMachineContext } from "../../types";
import type { ClearCartFulfillError } from "./events";
import type { PollFulfillResult } from "./services/pollFulfill";

export const actions = {
  setCartFulfillCipherText: assign(
    (ctx: FlightMachineContext, event: DoneInvokeEvent<CipherText>) =>
      setContextWithKey(
        ctx,
        `${ParentState.cartFulfill}.fulfillCipherText`,
        event.data
      )
  ),
  setCartFulfillError: assign(
    (ctx: FlightMachineContext, event: DoneInvokeEvent<CartFulfillError>) =>
      setContextWithKey(ctx, `${ParentState.cartFulfill}.error`, event.data)
  ),
  setCartFulfillPurchaseResult: assign(
    (ctx: FlightMachineContext, event: DoneInvokeEvent<PollFulfillResult>) => {
      const fulfillCtx = ctx[ParentState.cartFulfill];
      fulfillCtx.fulfilledPayments = event.data.payments;
      fulfillCtx.fulfilledProducts = event.data.products;
      return setContextWithKey(ctx, ParentState.cartFulfill, fulfillCtx);
    }
  ),
  clearCartFulfillError: assign(
    (ctx: FlightMachineContext, _event: ClearCartFulfillError) =>
      setContextWithKey(ctx, `${ParentState.cartQuote}.error`, undefined)
  ),
  clearCartFulfillUserActions: assign((ctx: FlightMachineContext) =>
    setContextWithKey(ctx, ParentState.cartFulfill, {
      ...ctx[ParentState.cartFulfill],
      userAction: undefined,
    })
  ),
  setUserAction: assign(
    (
      ctx: FlightMachineContext,
      event: DoneInvokeEvent<PollUserActionResponse>
    ) => {
      return setContextWithKey(ctx, ParentState.cartFulfill, {
        ...ctx[ParentState.cartFulfill],
        userAction:
          event.data.PollUserActionResponse === "NoAction"
            ? undefined
            : event.data,
      });
    }
  ),
};

export const ActionTypes = getObjectKeysAsObject(actions);
